import {useQuery} from 'react-query'
import {getStudentById} from '../app/pages/student/api'
import ViewAll from './ViewAll'
import viewProps from '../app/pages/viewProps'

const StudentDetails = ({studentId}: {studentId: string}) => {
  const {data, isLoading, error} = useQuery({
    queryKey: ['student', studentId],
    queryFn: () => getStudentById(studentId),
    enabled: !!studentId,
    refetchOnWindowFocus: false,
  })

  if (isLoading) return <p>Loading student...</p>
  if (error) return <p>Error loading student: {(error as Error).message}</p>
  const orderedFields = [
    ...Object.entries(viewProps.Student.primaryFieldsToLabelMap),
    ...Object.entries(viewProps.Student.secondaryFieldsToMap),
  ]
  return <ViewAll data={data.data} cellModifier={{}} fieldOrder={orderedFields} />
}
export default StudentDetails
